import * as types from './mutations-types'

export default {
  [types.m1] (state, val) {
    state.menuOpen = val
  },
  [types.showMenu] (state, val) {
    state.showMenu = val
  },
  [types.showHeader] (state, val) {
    state.showHeader = val
  },
  [types.showFooter] (state, val) {
    state.showFooter = val
  },
  [types.menuFolded] (state, val) {
    state.menuFolded = val
  }
}



// WEBPACK FOOTER //
// ./src/app/_default/store/mutations.js